import {defineStore} from 'pinia'
import {usePackageStore} from "./package";
import {uuid} from 'vue-uuid';

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useUserStore = defineStore('user', {
    state: () => ({
        id: null,
        name: '',
        first_name: '',
        last_name: '',
        business_name: '',
        email: '',
        street1: '',
        city: '',
        province: '',
        postal_code: '',
        gst_sbrn: '',
        paymentMethod:null,
        customerType:'personal',
        isLoggedIn:false,
        parcel_presets: [],
    }),

    actions: {
        async fetchMe() {
            await axios.get('/users/me').then(res => {
                if (res.data && res.data.id) {
                    this.id = res.data.id
                    this.isLoggedIn = true
                }
                this.setPresetPackage(res.data?.parcel_presets ?? [])

                if (res.data?.legal_infos?.[0]) {
                    const legalInfo = res.data?.legal_infos?.[0];

                    this.name = legalInfo.first_name + ' ' + legalInfo.last_name
                    this.first_name = legalInfo.first_name
                    this.last_name = legalInfo.last_name
                    this.business_name = legalInfo.business_name
                    this.email = legalInfo.email
                    this.street1 = legalInfo.street1
                    this.city = legalInfo.city
                    this.province = legalInfo.province
                    this.postal_code = legalInfo.postal_code
                    this.gst_sbrn = legalInfo.gst_sbrn
                }

                if (res.data?.payment_methods?.[0]) {
                    this.paymentMethod = res.data?.payment_methods?.[0]
                }

                if (res.data?.legal_infos?.[0]?.business_name) {
                    this.customerType = 'business'
                }
            }).catch(err => {
                // todo: handle error
            })
        },
        setPresetPackage(presets = []) {
            this.parcel_presets = [];

            presets.map(preset => {
                const packageStore = usePackageStore(uuid.v4());
                packageStore.$patch(preset);
                this.parcel_presets.push(packageStore);
            })
        },
        createAccountFromOrder(orderId, password) {
            return axios.post(`/orders/${orderId}/createAccount`, {password}).then(res => {
                console.log(res)
            })
        },
        updateAccountFromOrder(orderId, password) {
            return axios.post(`/orders/${orderId}/updateAccount`).then(res => {
                console.log(res)
            })
        },
        patchUser(data) {
            return axios.post(`/users/`, {...data, '_method': 'patch'}, {headers: {"Accept": "application/json"}})
        },
        savePackagePreset(newPackage) {
            if(this.parcel_presets.length > 4){
                alert('You can only save up to 5 presets. Please remove a preset first.')
                return;
            }

            const existing = this.parcel_presets.map(store => {
                return {
                    width: store.width,
                    height: store.height,
                    length: store.length,
                    weight: store.weight,
                    distance_unit: 'in',
                    mass_unit: 'lb',
                    value: store.value,
                    description: store.description,
                    country: store.country,
                }
            })

            const parcel_presets = [...existing, newPackage]

            axios.post(`/users/${this.id}`, {parcel_presets, '_method': 'patch'}, {headers: {"Accept": "application/json"}})
            .then(res => {
                const packageStore = usePackageStore(uuid.v4());
                packageStore.$patch(newPackage); 
                this.parcel_presets.push(packageStore);

                alert('Preset saved')
            })
            .catch(err => {
                alert(`${err.response.data?.parcel_presets.join("\n")}`)
                console.log(err)
            })
        },
        removePreset(uuid) {
            // confirm with alert box
            if(!confirm('Are you sure you want to remove this preset?')){
                return;
            }

            this.parcel_presets = this.parcel_presets.filter(preset => preset.uuid !== uuid)
            const parcel_presets = this.parcel_presets.map(store => {
                return {
                    width: store.width,
                    height: store.height,
                    length: store.length,
                    weight: store.weight,
                    distance_unit: 'in',
                    mass_unit: 'lb',
                    value: store.value,
                    description: store.description,
                    country: store.country,
                }
            })
            
            return axios.post(`/users/${this.id}`, {parcel_presets, '_method': 'patch'}, {headers: {"Accept": "application/json"}})
            .catch(err => {
                console.log(err)
                alert('Failed to remove preset.')
            })
            

        }
    },
})
